import { dateFormatter } from '@/helpers/dateFormatter'
import {
  EDIT, TableAction, TableActionsTypes, VIEW,
} from '@/helpers/enums/table-actions'
import { userNameInitials } from '@/helpers/nameFormatter'
import {
  getMunMehFormActionTypeText,
  getMunMehFormStatusText,
  getMunMehFormUserActionHistoryDataText,
  MunMehCuratorForm,
  MunMehFormStatuses, MunMehFormUserActionHistoryData, MunMehFormUserActionHistoryIndicator,
} from '@/typings/api/MunMeh'

const SAVE: TableAction<MunMehCuratorForm> = {
  action: TableActionsTypes.accept,
  icon: 'mdi-content-save',
  tooltip: 'Сохранить экспертов',
  getFilter: (v: MunMehCuratorForm) => v.changed,
}

export const FINISH: TableAction<MunMehCuratorForm> = {
  action: TableActionsTypes.finish,
  icon: 'mdi-check',
  color: 'success',
  tooltip: 'Подтвердить завершение работы с формой',
  getFilter: (v: MunMehCuratorForm) => (
    v.status === MunMehFormStatuses.second_level_marked
  ),
}

export const SUPER_ADMIN_ACTION: TableAction<MunMehCuratorForm> = {
  action: TableActionsTypes.admin,
  icon: 'mdi-check',
  tooltip: 'Смена статуса',
}

export const TABLE_ACTIONS = Object.freeze([
  SAVE,
  VIEW,
  FINISH,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Логин / Пользователь',
    value: 'username',
    sortable: false,
    field: (value: MunMehCuratorForm) => [value.username, userNameInitials(value.user_full_name)].join('<br />'),
  },
  {
    text: 'Статус',
    value: 'is_submitted',
    sortable: false,
    width: 130,
    field: getMunMehFormStatusText,
  },
  {
    text: 'Дата начала работы',
    value: 'created_at',
    sortable: true,
    width: 155,
    field: (value: MunMehCuratorForm['created_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата подачи',
    value: 'submitted_at',
    sortable: true,
    width: 144,
    field: (value: MunMehCuratorForm['submitted_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Эксперт 1',
    value: 'first_level_expert_one_id',
    sortable: true,
    width: 180,
  },
  {
    text: 'Эксперт 2',
    value: 'first_level_expert_two_id',
    sortable: true,
    width: 180,
  },
  {
    text: 'Эксперт 3',
    value: 'second_level_expert_id',
    sortable: true,
    width: 180,
  },
  {
    text: 'Отчеты',
    value: 'reports',
    sortable: false,
    width: 130,
    getFilter: (v: MunMehCuratorForm) => v.status === MunMehFormStatuses.finished,
  },
])

export const EXPERT_TABLE_ACTIONS = Object.freeze([
  {
    ...EDIT,
    tooltip: 'Перейти к экспертизе',
    getFilter: (v: MunMehCuratorForm) => (
      v.expert_status === MunMehFormStatuses.expert_not_started
        || v.expert_status === MunMehFormStatuses.expert_in_progress
    ),
  },
  {
    ...VIEW,
    tooltip: 'Смотреть',
    getFilter: (v: MunMehCuratorForm) => v.expert_status === MunMehFormStatuses.expert_done,
  },
])

export const EXPERT_TABLE_HEADERS = Object.freeze([
  {
    text: 'Логин',
    value: 'username',
    sortable: false,
  },
  {
    text: 'Статус Экспертизы',
    value: 'expert_status',
    sortable: false,
    width: 130,
    field: getMunMehFormStatusText,
  },
  // {
  //   text: 'Дата сдачи формы',
  //   value: 'submitted_at',
  //   sortable: false,
  //   width: 155,
  //   field: (value: MunMehCuratorForm['submitted_at']) => (
  //     value && dateFormatter(value)
  //   ),
  // },
  // {
  //   text: 'Дата экспертизы',
  //   value: 'expertise_1_at',
  //   sortable: false,
  //   width: 144,
  //   field: (value: MunMehCuratorForm['expertise_1_at']) => (
  //     value && dateFormatter(value)
  //   ),
  // },
])

export const LOGS_TABLE_HEADERS = [
  // {
  //   text: 'Логин',
  //   value: 'username',
  //   sortable: false,
  // },
  // {
  //   text: 'Тип',
  //   value: 'type',
  //   sortable: false,
  //   field: (v: MunMehFormUserActionHistory) => getMunMehFormActionObjectTypeText(v.type),
  // },
  {
    text: 'Тип действия',
    value: 'action_type',
    width: '150px',
    sortable: false,
    getValue: (v: MunMehFormUserActionHistoryIndicator) => getMunMehFormActionTypeText(v.action_type),
  },
  // {
  //   text: 'IP',
  //   value: 'ip',
  //   width: '100px',
  //   sortable: false,
  // },
  {
    text: 'Данные до изменения',
    value: 'old_data',
    sortable: false,
    style: 'font-size: 11px;',
    getValue: (v: MunMehFormUserActionHistoryIndicator) => (v?.old_data
      ?.map((el: MunMehFormUserActionHistoryData) => getMunMehFormUserActionHistoryDataText(el))
      .join('')) || 'Нет данных',
  },
  {
    text: 'Измененные данные',
    value: 'new_data',
    sortable: false,
    style: 'font-size: 11px;',
    getValue: (v: MunMehFormUserActionHistoryIndicator) => (v?.new_data
      ?.map((el: MunMehFormUserActionHistoryData) => getMunMehFormUserActionHistoryDataText(el))
      .join('')) || 'Нет данных',
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: false,
    width: 155,
    getValue: (value: MunMehFormUserActionHistoryIndicator) => (
      value.created_at && dateFormatter(value.created_at)
    ),
  },
]

export const LOGS_TABLE_ACTIONS = [
  {
    ...VIEW,
    // getFilter: (v: MunMehFormUserActionHistory) => !!v.indicator_id,
  },
]
